import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import DailyFeatures from './components/DailyFeatures';
import MenuSection from './components/MenuSection';
import OrderSection from './components/OrderSection';
import ContactSection from './components/ContactSection';
import CateringSection from './components/CateringSection';
import EventsSection from './components/EventsSection';
import CareersSection from './components/CareersSection';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <FeaturedSection />
        <DailyFeatures />
        <MenuSection />
        <OrderSection />
        <ContactSection />
        <CateringSection />
        <EventsSection />
        <CareersSection />
      </main>
      <Footer />
    </div>
  );
}

export default App; 